import { PageHeader } from "@ceedero/ui";

import { AvatarSection } from "@/account/components/account-page/avatar-section";
import { DeleteAccountSection } from "@/account/components/account-page/delete-account-section";
import { DisplayNameSection } from "@/account/components/account-page/display-name-section";
import { AppPage } from "@/components/app-page";
import { PasswordSection } from "@/account/components/account-page/password-section";
import { SessionSection } from "@/account/components/account-page/session-section";
import { UsernameSection } from "@/account/components/account-page/username-section";
import { useAccountProfile } from "@/account/hooks/use-account";
import { useTranslation } from "@/localization/hooks/use-translation";

/**
 * Everything about the account itself: what it is called, how it is signed in
 * to, and how to end every session at once.
 *
 * The profile is already loaded by the time this renders — the shell asks for
 * it to decide whether to draw a sign-in page at all — so there is no loading
 * state here beyond the one case the shell cannot rule out, a cache cleared
 * underneath it.
 */
export const AccountPage = () => {
  const { t } = useTranslation();
  const profile = useAccountProfile();

  if (!profile.data) {
    return null;
  }

  return (
    <AppPage
      width="wide"
      header={<PageHeader title={t("account.title")} description={t("account.description")} />}
    >
      <div className="flex flex-col gap-8">
        <AvatarSection profile={profile.data} />
        <DisplayNameSection profile={profile.data} />
        <UsernameSection profile={profile.data} />
        <PasswordSection />
        <SessionSection />
        <DeleteAccountSection />
      </div>
    </AppPage>
  );
};
